import "../resource_collection/behavior.js";

class PhysiciansBehavior extends Sparkle.PageBuilder.Components.ResourceCollectionAbstractBehavior {
  constructor() {
    super(...arguments);
    this.slideshowOptions = this.slideshowOptions.bind(this);
  }

  slideshowOptions() {
    return {
      arrows: true,
      dots: false,
      regionLabel: "Physician Carousel",
    };
  }
}
// Each behavior must be registered with the name of the component template
PhysiciansBehavior.register("physicians");
